import { ReactElement, useState } from 'react';
import { useFormikContext } from 'formik';
import { Button, PayForm } from '@components';
import { navigateToError } from '@utils';
import { iCourtFormValues } from '@services/CourtService';
import styles from './CourtStep8.module.scss';

const { REACT_APP_SITECORE_API_ENDPOINT: API_URL } = process.env;

function CourtStep8(): ReactElement {
  const [loading, setLoading] = useState(false);
  const { values }: { values: iCourtFormValues } = useFormikContext();

  return (
    <>
      {!loading && (
        <div className={styles.step8}>
          <div className="vfH2">You're not eligible to go to court</div>
          <p className={styles.intro}>
            Your fines has reached the enforcement stage of the fines lifecycle. At this stage, you're not eligible to have your matter heard in court. If you would like to dispute
            this fine, you'll need to request a review.
          </p>
          <p />
          <p className={styles.subtext}>
            {'To speak to someone, contact Fines Victoria on '}
            <a href="tel:0392008222">03 9200 8222</a>
            {' or '}
            <a href="tel:1800150410">1800 150 410</a>
            {' (for regional callers).'}
          </p>
          <p />
          <p className={styles.subtext}> We are available Monday to Friday, 8am to 6pm (except public holidays).</p>
          <div className={styles.row}>
            {/* Pay your fines */}
            <PayForm obligationNumber={values.OBLIGATION_NUMBER} />
            {/* View your fines */}
            <Button
              onClick={async (): Promise<void> => {
                setLoading(true);
                const payload = {
                  page: 'fines.YourFinesListID',
                };
                const url = `${API_URL}sitecore/Navigation/GetUrl`;
                let response: any;
                try {
                  response = await fetch(url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                  });
                  const responseUrl = await response.json();
                  setLoading(false);
                  if (response.status === 200) {
                    window.location.href = responseUrl;
                    return;
                  }
                  navigateToError();
                } catch (error) {
                  navigateToError();
                }
              }}
              size="medium"
              color="transparent"
              className={styles.button}>
              View your fines
            </Button>

            {/* Request to have your fines reviewed */}
            <Button
              onClick={async (): Promise<void> => {
                setLoading(true);
                const payload = {
                  page: 'fines.ReviewFormFineStage',
                };
                const url = `${API_URL}sitecore/Navigation/GetUrl`;
                let response: any;
                try {
                  response = await fetch(url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                  });
                  const responseUrl = await response.json();
                  setLoading(false);
                  if (response.status === 200) {
                    window.location.href = responseUrl;
                    return;
                  }
                  navigateToError();
                } catch (error) {
                  navigateToError();
                }
              }}
              size="small"
              color="transparent"
              className={styles.button}>
              Request to have your fines reviewed
            </Button>
          </div>
          <div className={styles.note}>
            <a href="/About-Fines/What-happens-if-you-dont-pay">Find out what could happen if you don't pay</a>
          </div>
        </div>
      )}
    </>
  );
}

export default CourtStep8;
